import React from 'react';

import { cn } from 'helpers/classnames';
import useMartyContext from 'hooks/useMartyContext';
import ReturnPackagelessTooltip from 'components/account/Returns/ReturnPackagelessTooltip';
import ReturnInstructionsSection from 'components/account/Returns/ReturnInstructionsSection';
import { PROVIDE_LABEL_OPTIONS } from 'constants/exchanges';
import ReturnLabelOption from 'components/account/Returns/ReturnLabelOption';
import StoreIcon from 'images/zappos/packageless-method.svg';
import { WFM_FIND_STORE_URL } from 'constants/appConstants';
import External from 'images/zappos/external.svg';

// eslint-disable-next-line css-modules/no-unused-class
import css from 'styles/containers/returns/returnLabelOption.scss';

// WFM = Whole Foods Market
const WFMPackagelessOption = ({
  labelDelivery,
  customerInfo,
  onReturnMethodSelect,
  showInstructions,
  showInstructionsHandler,
  showPackagelessReturn,
  displayOnly,
  className
}) => {
  const {
    marketplace: { dataMaskPiiElements }
  } = useMartyContext();

  if (!showPackagelessReturn) {
    return null;
  }

  const expandedInfo = (
    <div className={css.additionalInfo}>
      {customerInfo?.email && (
        <p className={css.infoTitle} data-cs-mask={dataMaskPiiElements}>
          Return code will be sent to: <span className={css.additionalInfoContent}>{customerInfo.email}</span>
        </p>
      )}
    </div>
  );

  const checked = labelDelivery === PROVIDE_LABEL_OPTIONS.WFM_PACKAGELESS;
  const returnInstructionsSection = (
    <ReturnInstructionsSection
      checked={labelDelivery === PROVIDE_LABEL_OPTIONS.WFM_PACKAGELESS}
      displayOnly={displayOnly}
      showInstructions={showInstructions}
      showInstructionsHandler={showInstructionsHandler}
      value={PROVIDE_LABEL_OPTIONS.WFM_PACKAGELESS}
      storeIcon={StoreIcon}
    />
  );
  const optionInformation = (
    <>
      <b>
        Without shipping box and label <ReturnPackagelessTooltip />
      </b>
      <p className={cn(css.optionInfo, { [css.checkedOptionInfo]: checked })}>
        Show your return code at any{' '}
        <a href={WFM_FIND_STORE_URL} target="_blank" rel="noopener noreferrer">
          Whole Foods Market
          <img src={External} alt={'external'} />
        </a>{' '}
        and we will take care of the rest.
      </p>
      {checked && !displayOnly && expandedInfo}
    </>
  );
  const labelButtonsGroup = (
    <div className={css.labelButtonsWrapper}>
      <a href={WFM_FIND_STORE_URL} target="_blank" rel="noopener noreferrer" className={css.externalLink}>
        Find Whole Foods Market <img src={External} alt={'external'} />
      </a>
    </div>
  );

  return (
    <ReturnLabelOption
      badge="Recommended"
      checked={checked}
      children={returnInstructionsSection}
      icon={StoreIcon}
      id={PROVIDE_LABEL_OPTIONS.WFM_PACKAGELESS}
      optionTitle="Drop-off"
      optionInformation={optionInformation}
      onReturnMethodSelect={onReturnMethodSelect}
      showInstructions={showInstructions}
      showInstructionsHandler={showInstructionsHandler}
      value={PROVIDE_LABEL_OPTIONS.WFM_PACKAGELESS}
      displayOnly={displayOnly}
      labelButtonsGroup={labelButtonsGroup}
      className={className}
    />
  );
};
export default WFMPackagelessOption;
